<nav>
	<div class="navbar">
		<div class="left">
			<img [src]="logoUrl" alt="Logo" class="logo" />
			<div class="brand">
				@if (brandLine2()) {
				<span>{{ brandLine1() }}</span>
				<strong>{{ brandLine2() }}</strong>
				} @else { {{ displayEvent() }} }
			</div>
		</div>

		<div class="right">
			@for (item of menuItems(); track item.route) {
			<a>{{ item.display }}</a>
			}

			<button class="btn btn-primary" (click)="login()">
				Connexion
				<lucide-icon [img]="LogIn"></lucide-icon>
			</button>
		</div>

		<button class="hamburger" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen()" aria-label="Menu">
			<lucide-icon [img]="menuOpen() ? X : Menu" [size]="24"></lucide-icon>
		</button>
	</div>

	@if (menuOpen()) {
	<div class="mobile-menu">
		@for (item of menuItems(); track item.route) {
		<a (click)="closeMenu()">{{ item.display }}</a>
		}

		<div class="mobile-menu__bottom">
			<button class="btn btn-primary" (click)="login(); closeMenu()">
				Connexion
				<lucide-icon [img]="LogIn"></lucide-icon>
			</button>
		</div>
	</div>
	}
</nav>
